import { useState } from "react";

import Button from "../Buttons/Button";

export default function OpenButton({ text, children, ...props }) {
	const [open, setOpen] = useState(false);

	return (
		<>
			<Button disabled={open} onClick={() => setOpen(true)} {...props}>
				{text}
			</Button>

			{open &&
				(typeof children === "function"
					? children({
							open,
							setOpen,
							onClose: () => setOpen(false),
					  })
					: children)}
		</>
	);
}
